module.exports = __webpack_public_path__ + "static/media/home-bg.7435e287.png";